import Dashboard from '../views/Dashboard';
import Profile from '../views/Profile';
import TwoFactorAuthenticationVerification from '../views/TwoFactorAuthenticationVerification';
import TwoFactorAuthenticationSetup from '../views/TwoFactorAuthenticationSetup';

export default [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            title: 'Dashboard',
        },
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta: {
            title: 'Profile',
        },
    },
    {
        path: '/2fa/verify',
        name: '2fa-verify',
        component: TwoFactorAuthenticationVerification,
        meta: {
            title: 'Two-Factor Authentication - Verification',
        },
    },
    {
        path: '/2fa/setup',
        name: '2fa-setup',
        component: TwoFactorAuthenticationSetup,
        meta: {
            title: 'Two-Factor Authentication - Setup',
        },
    },
];
